module.exports = __webpack_public_path__ + "media/images/pc/stores/common/instagram/hairmake_sns_03-fb8212fa56babb45cf56453f65f95411.jpg";